module.exports = __webpack_public_path__ + "static/media/home-banner-blue-swirl.471a597e.svg";